<template>
  <div class="flex items-center justify-center" style="height: calc(100dvh - 48px)">
    <RfSpinnerIcon class="fill-grey-1 animate-spin" />
  </div>
</template>

<script setup>
import RfSpinnerIcon from "@/components/icons/RfSpinnerIcon.vue";
import { useToastsStore } from "@/pinia/toastsStore";
import { computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

const toastsStore = useToastsStore();
const route = useRoute();
const router = useRouter();

const isConnected = computed(() => {
  return route.name === "Figma Connect Success";
});

onMounted(() => {
  router.replace({ path: `/apps/${route.params.aid}/settings/connectors` });

  toastsStore.create({
    type: isConnected.value ? "success" : "error",
    body: isConnected.value ? "Figma connected successfully" : "Figma connection failed",
    timeout: 5000,
  });
});
</script>
